"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NETWORK_INFO = exports.NATIVE_TOKEN_ADDRESS = void 0;
const types_1 = require("../types");
// defined by Qubic backend
exports.NATIVE_TOKEN_ADDRESS = '0x0000000000000000000000000000000000455448';
const ETHEREUM_NATIVE_TOKEN = {
    symbol: 'ETH',
    address: exports.NATIVE_TOKEN_ADDRESS,
    decimals: 18,
};
const POLYGON_NATIVE_TOKEN = {
    symbol: 'MATIC',
    address: exports.NATIVE_TOKEN_ADDRESS,
    decimals: 18,
};
const BSC_NATIVE_TOKEN = {
    symbol: 'BNB',
    address: exports.NATIVE_TOKEN_ADDRESS,
    decimals: 18,
};
exports.NETWORK_INFO = {
    [types_1.Network.MAINNET]: {
        name: 'mainnet',
        chainId: types_1.Network.MAINNET,
        ensAddress: '0x314159265dd8dbb310642f98f50c066173c1259b',
        explorerUrl: 'https://etherscan.io',
        color: '#3cc29e',
        nativeToken: ETHEREUM_NATIVE_TOKEN,
        networkType: 'ethereum',
    },
    [types_1.Network.ROPSTEN]: {
        name: 'ropsten',
        chainId: types_1.Network.ROPSTEN,
        ensAddress: '0x112234455c3a32fd11230c42e7bccd4a84e02010',
        explorerUrl: 'https://ropsten.etherscan.io',
        color: '#ff4a8d',
        nativeToken: ETHEREUM_NATIVE_TOKEN,
        networkType: 'ethereum',
    },
    [types_1.Network.RINKEBY]: {
        name: 'rinkeby',
        chainId: types_1.Network.RINKEBY,
        ensAddress: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
        explorerUrl: 'https://rinkeby.etherscan.io',
        color: '#f6c343',
        nativeToken: ETHEREUM_NATIVE_TOKEN,
        networkType: 'ethereum',
    },
    [types_1.Network.POLYGON]: {
        name: 'polygon',
        chainId: types_1.Network.POLYGON,
        ensAddress: '0x0000000000000000000000000000000000000000',
        explorerUrl: 'https://polygonscan.com',
        color: '#8247e5',
        nativeToken: POLYGON_NATIVE_TOKEN,
        networkType: 'polygon',
    },
    [types_1.Network.MUMBAI]: {
        name: 'mumbai',
        chainId: types_1.Network.MUMBAI,
        ensAddress: '0x0000000000000000000000000000000000000000',
        explorerUrl: 'https://mumbai.polygonscan.com',
        color: '#de4437',
        nativeToken: POLYGON_NATIVE_TOKEN,
        networkType: 'polygon',
    },
    [types_1.Network.BSC]: {
        name: 'bsc',
        chainId: types_1.Network.BSC,
        ensAddress: '0x0000000000000000000000000000000000000000',
        explorerUrl: 'https://bscscan.com',
        color: '#F0B90b',
        nativeToken: BSC_NATIVE_TOKEN,
        networkType: 'bsc',
    },
    [types_1.Network.BSC_TESTNET]: {
        name: 'bscTestnet',
        chainId: types_1.Network.BSC_TESTNET,
        ensAddress: '0x0000000000000000000000000000000000000000',
        explorerUrl: 'https://testnet.bscscan.com',
        color: '#12161c',
        nativeToken: BSC_NATIVE_TOKEN,
        networkType: 'bsc',
    },
};
